import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '@HoudiniUI/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
		gap: SPACE[8],
	},
	label: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	placeholder: {
		color: THEME.colors.text.light,
	},
	trigger: {
		minWidth: 220,
	},
	triggerValue: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
});
